import { AxiosError } from "axios";
import { api } from "../../api/api";
import Corretor from "../../model/Corretor";

export default class CorretorService {
    buscarTodos() {
        return new Promise<Corretor[]>((resolve, reject): void => {
            api.get("/corretor")
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    alterarEmail(id: number, email: string) {
        return new Promise<void>((resolve, reject): void => {
            api.put(`/corretor/${id}/email`, { email })
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    integrar() {
        return new Promise<void>((resolve, reject): void => {
            api.get("/corretor/integrar")
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}
